import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Select, Input } from 'antd';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { storeComment, updateComment } from '@app/api/prImportFreeSales.api';
import { Comment } from '@app/models/import_free_sales/ImpFreeSalesResponse';

interface CommentsProps {
  commentData: any[];
  //editable: boolean;
  status: string | null;
  pr_id: string | null;
}

const CommentsTab: React.FC<CommentsProps> = ({ commentData, pr_id, status }) => {
  const [comments, setComments] = useState<any[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingComment, setEditingComment] = useState<any | null>(null);
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const [editable, setEditable] = useState(true);
  useEffect(() => {
    if (status === 'DONE' || status === 'CANCELLED' || status === 'REJECTED') {
      setEditable(false);
    } else {
      setEditable(true);
    }
  }, [status]);
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const formattedComments = commentData.map((comment: Comment) => ({
      ...comment,
      updated_at: new Date(comment.updated_at).toLocaleString(),
      user: comment.user_id === user.id ? user.name : 'Admin',
    }));
    setComments(formattedComments);
    console.log('CommentsTab commentData:', formattedComments);
  }, [commentData]);

  const user = JSON.parse(localStorage.getItem('user') || '{}')?.name || 'Unknown User';

  const handleAddOrEditComment = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      const newComment = {
        comment_for: values.commentFor ?? 'USER',
        comment: values.comment,
      };

      let res;
      if (editingComment) {
        res = await updateComment(Number(pr_id), editingComment.id, newComment);
      } else {
        res = await storeComment(Number(pr_id), newComment);
      }

      if (res?.data?.pr_comments) {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const formattedComments = res.data.pr_comments.map((comment: Comment) => ({
          ...comment,
          updated_at: new Date(comment.updated_at).toLocaleString(),
          user: comment.user_id === user.id ? user.name : 'Admin',
        }));
        setComments(formattedComments);
      }

      setIsModalVisible(false);
      setEditingComment(null);
      form.resetFields();
    } catch (error) {
      console.error('Failed to add or edit comment:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (record: any) => {
    setEditingComment(record);
    setIsModalVisible(true);
    form.setFieldsValue({
      commentFor: record.comment_for,
      comment: record.comment,
    });
  };

  const columns = [
    { title: 'Date & Time', dataIndex: 'updated_at', key: 'updated_at', width: 180 },
    { title: 'Status', dataIndex: 'status', key: 'status', width: 120 },
    { title: 'User', dataIndex: 'user', key: 'user', width: 150 },
    { title: 'Comment For', dataIndex: 'comment_for', key: 'comment_for', width: 150 },
    { title: 'Comment', dataIndex: 'comment', key: 'comment', width: 300 },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      render: (_: any, record: any) => (
        <>
          <EditOutlined
            disabled={!editable || record.status !== status} // Disable if statuses don't match
            style={{
              marginRight: 8,
              color: record.status !== status ? 'gray' : '#1890ff',
            }}
            onClick={() => record.status === status && handleEdit(record)}
          />
        </>
      ),
    },
  ];

  return (
    <>
      {editable && (
        <Button
          type="primary"
          onClick={() => setIsModalVisible(true)}
          icon={<PlusOutlined />}
          disabled={!editable}
          size="small"
        >
          Add Comment
        </Button>
      )}
      <Table
        columns={columns}
        dataSource={comments}
        rowKey="id"
        style={{ marginTop: 16 }}
        pagination={{ pageSize: 5 }}
        size="small"
      />

      <Modal
        title={editingComment ? 'Edit Comment' : 'Add Comment'}
        open={isModalVisible}
        onOk={handleAddOrEditComment}
        confirmLoading={isLoading}
        onCancel={() => {
          setIsModalVisible(false);
          setEditingComment(null);
          form.resetFields();
        }}
      >
        <Form form={form} layout="vertical">
          {user === 'Admin' && (
            <Form.Item
              name="commentFor"
              label="Comment For"
              rules={[{ required: true, message: 'Please select an option' }]}
            >
              <Select placeholder="Select">
                <Select.Option value="CUSTOMER">Customer</Select.Option>
                <Select.Option value="USER">System Admin</Select.Option>
              </Select>
            </Form.Item>
          )}
          <Form.Item name="comment" label="Comment" rules={[{ required: true, message: 'Please enter a comment' }]}>
            <Input.TextArea placeholder="Enter your comment" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CommentsTab;
